import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { NetworkIntegrityGapImpactReportPanelBody, getGapImpactTypeLabel } from "./NetworkIntegrityGapImpactReportPanelBody";
import { RouteMatchParams } from "../models";
import { AccordionContainer } from "@app/shared/AccordionContainer";
import { Accordion } from "@app/shared/Accordion";

interface NetworkIntegrityGapImpactReportPanelProps extends RouteMatchParams {
  isProviderDetailAvailable: boolean;
}

const NetworkIntegrityGapImpactReportPanel = (props: NetworkIntegrityGapImpactReportPanelProps): JSX.Element => {
  const gapIcon = <QesIcon isDecorative iconName={QesIcons.UserV1} width="14" height="14" className="align-baseline me-1" style={{ position: "relative", top: "1px" }} />;
  const panelTitle = <>{gapIcon} Gap Detail - {getGapImpactTypeLabel(props.impactType)}</>;

  return (
    <AccordionContainer>
      <Accordion
        testId="network-integrity-gap-impact-report-panel_accordion"
        title={panelTitle}
        defaultOpen={true}>
        <NetworkIntegrityGapImpactReportPanelBody {...props} />
      </Accordion>
    </AccordionContainer>
  );
}

export { NetworkIntegrityGapImpactReportPanel };
